import { useState, useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import Navbar from '../components/Navbar'
import CartSidebar from '../components/CartSidebar'
import Footer from '../components/Footer'
import MobileFooter from '../components/navigation/MobileFooter'
import AutoLogoutProvider from '../components/AutoLogoutProvider'
import { getAutoLogoutConfig } from '../config/autoLogout'
import { useAuthStore } from '../store/authStore'

export default function GuestLayout() {
  const { isAuthenticated } = useAuthStore()
  const autoLogoutConfig = getAutoLogoutConfig()
  const [isMobile, setIsMobile] = useState(false)

  // Check if we're on mobile viewport
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768) // md breakpoint
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  const content = (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col">
      <Navbar />
      <div className="flex-1 md:pt-0 pt-16">
        <Outlet />
      </div>
      {!isAuthenticated ? (
        <Footer />
      ) : isMobile ? (
        <MobileFooter />
      ) : (
        <Footer />
      )}
      <CartSidebar />
    </div>
  )

  // Only wrap with AutoLogoutProvider if user is authenticated
  // This handles authenticated routes like /checkout and /order-success that use GuestLayout
  if (isAuthenticated) {
    return (
      <AutoLogoutProvider
        timeoutMinutes={autoLogoutConfig.timeoutMinutes}
        warningMinutes={autoLogoutConfig.warningMinutes}
        enabled={autoLogoutConfig.enabled}
      >
        {content}
      </AutoLogoutProvider>
    )
  }

  return content
} 